import React,{useState} from 'react';
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Container, Button, Form, Modal 
} from "react-bootstrap";
import FocusTrap from "focus-trap-react";
import http from "../../api/http-request";
import CloseIcon from "../../assets/images/close-icon.svg";

const RenameDevicePopup = (props) =>{
    const {t} = useTranslation();
    const {onClose,identifier,userData:{userName},renameDevicePrompt,alias} = props;
    const [rename , setRename] = useState(alias);
    const [nameError , setNameError] = useState(false);
    const renameChangeHandler = (e) =>{
        const value = e.target.value;
        if(value.length > 256){
            setNameError(true)
            return
        }else {
            setRename(value);
            setNameError(false)
        }
    }
    const data = {
        identifier:'',
        alias:''
    }
    const onSave = (e) =>{
        e.preventDefault();
        const bearer = 'Bearer ';
        const dataStoreToken = localStorage.getItem("authToken");
        data.identifier = identifier;
        data.alias = rename;
        http({
            url:`users/${encodeURIComponent(userName)}/devices/profile/${identifier}`,
            method:"PUT",
            data:JSON.stringify(data)
          },
          {
            Authorization:`${bearer}${dataStoreToken}`,
            "Accept-API-Version": "protocol=1.0,resource=1.0"
      
          }).then((res)=>{
            const response = res;
            console.log(response);
            if(res.status ===200 && res.data.alias){
               renameDevicePrompt("success",userName);
               onClose();
            }else if(res.status === 401 && res.code==="401"){
                renameDevicePrompt("error");
                onClose();
            }
          })
    }
    return(
        <Modal
            show
            animation={false}
            onEscapeKeyDown={() => onClose()}
            aria-labelledby="mobile-modal"
        >
            <FocusTrap>
            <div className="popup change-mobile-number">
                <Container fluid>
                <div className="popup__wrapper">
                    <Form>
                    <div className="popup__wrapper-body">
                        <div className="popup__wrapper-body-header">
                        <h6 id="mobile-modal">
                            {t("pages.profile.renameDevice")}
                        </h6>
                        <Button
                            className="popup__wrapper-body-header-close"
                            onClick={() => {
                            onClose();
                            }}
                            variant="light"
                            aria-label="Close"
                        >
                            <img src={CloseIcon} alt="" />
                        </Button>
                        </div>
                        <>
                            <p className="popup__wrapper-body-desc">
                            {t("pages.profile.renameDeviceDesc")}
                            </p>
                            <div className="popup__wrapper-body-email">
                            <Form.Group controlId="name">
                                <Form.Label>
                                {t("pages.profile.newName")}
                                </Form.Label>
                                <Form.Control
                                type="text"
                                onChange={renameChangeHandler}
                                value={rename}
                                aria-required
                                className={nameError ? "error-input" : undefined}
                                aria-invalid={!!nameError}
                                aria-describedby="name-error"
                                />
                                
                            </Form.Group>
                            </div>
                            <p className="error-text" id="name-error">
                            {nameError && t("pages.profile.nameError")}
                            </p>
                        </>
                    </div>
                    <div className="popup__wrapper-footer">
                        <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => onSave(e)}
                        >
                            {t("pages.profile.save")}
                        </Button>
                    </div>
                    </Form>
                </div>
                </Container>
            </div>
            </FocusTrap>
        </Modal>
    );
}

export default RenameDevicePopup;